/**
 * Creates and caches a WebGPU node material for the world-space normal debug material.
 */
import { GenesysWorldNormalNodeMaterial } from './GenesysWorldNormalNodeMaterial.js';

/** The `name` set on `MaterialUtils.MeshWorldSpaceNormalMaterial` used for renderer identification. */
export const WORLD_NORMAL_MATERIAL_NAME = 'MeshWorldSpaceNormalMaterial';

let webGpuWorldNormalMaterial: GenesysWorldNormalNodeMaterial | null = null;

/**
 * Returns a shared {@link GenesysWorldNormalNodeMaterial} instance for use on the WebGPU backend.
 * The source `ShaderMaterial` has no per-instance state to mirror, so a single shared instance suffices.
 */
export function getOrCreateWebGpuWorldNormal(): GenesysWorldNormalNodeMaterial {
  webGpuWorldNormalMaterial ??= new GenesysWorldNormalNodeMaterial();
  return webGpuWorldNormalMaterial;
}
